"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable no-shadow */
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const suggests_1 = require("src/hooks/suggests");
const branding_1 = require("src/context/branding");
const input_1 = __importDefault(require("src/components/input"));
const question_1 = __importDefault(require("../question"));
const question_geo_suggestions_1 = __importDefault(require("./question-geo-suggestions"));
const question_geo_text_styles_1 = __importDefault(require("./question-geo-text.styles"));
const initialItemIndex = -1;
function Geo(_a) {
    var { id, value: initialValue = '', accuracy = 'locality', lang = 'ru', handleChange, handleBlur, handleSelect, type } = _a, rest = __rest(_a, ["id", "value", "accuracy", "lang", "handleChange", "handleBlur", "handleSelect", "type"]);
    const { geo: { suggestCount = 5, scroll: { view = 'default' } = {} } = {} } = (0, branding_1.useBrandingContext)() || {};
    const [value, setValue] = (0, react_2.useState)(initialValue);
    const [itemIndex, setItemIndex] = (0, react_2.useState)(initialItemIndex);
    (0, react_2.useEffect)(() => {
        if (!initialValue) {
            setValue('');
        }
    }, [initialValue]);
    const { suggestItems, fetchSuggestions, clearSuggestions } = (0, suggests_1.useSuggestions)(accuracy, lang, suggestCount);
    const controlRef = (0, react_2.useRef)(null);
    const handleInputChange = (e) => __awaiter(this, void 0, void 0, function* () {
        setValue(e.target.value);
        handleChange(e);
        setItemIndex(initialItemIndex);
        yield fetchSuggestions(e.target.value);
    });
    const handleInputKeyDown = (e) => {
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setItemIndex(prevIndex => {
                    const newIndex = (prevIndex + 1) % suggestItems.length;
                    return newIndex;
                });
                break;
            case 'ArrowUp':
                e.preventDefault();
                setItemIndex(prevIndex => {
                    const newIndex = (prevIndex - 1 + suggestItems.length) % suggestItems.length;
                    return newIndex;
                });
                break;
            case 'Enter':
                if (itemIndex > initialItemIndex && suggestItems.length > 0) {
                    const selected = suggestItems[itemIndex];
                    setValue(selected.displayName);
                    clearSuggestions();
                    setItemIndex(initialItemIndex);
                    handleSelect({ index: id, value: selected.displayName });
                }
                break;
            case 'Escape':
                clearSuggestions();
                break;
            default:
                break;
        }
    };
    const handleSuggestionClick = (0, react_2.useCallback)((displayName, value) => {
        setValue(displayName);
        clearSuggestions();
        handleSelect({ index: id, value });
    }, [clearSuggestions, handleSelect, id]);
    const appliedStyles = (0, question_geo_text_styles_1.default)(view);
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: appliedStyles }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: type }, { children: [(0, jsx_runtime_1.jsx)(input_1.default, { "data-index": id, size: 'dependent', value: value, role: 'combobox', "aria-autocomplete": 'list', "aria-controls": 'listbox', "aria-expanded": suggestItems.length > 0 || undefined, "aria-activedescendant": itemIndex > -1 ? `suggestion-${itemIndex}` : undefined, onChange: handleInputChange, onBlur: handleBlur, onKeyDown: handleInputKeyDown, ref: controlRef }), (0, jsx_runtime_1.jsx)(question_geo_suggestions_1.default, { suggestItems: suggestItems, itemIndex: itemIndex, handleSuggestionClick: handleSuggestionClick, clearSuggestions: clearSuggestions })] }))] })));
}
exports.default = Geo;
